import { useState } from "react";

import { CatCount, MAX_CAT_COUNT } from "../constants";

export interface IUseCatCountFormReturn {
  selectedCatCount: CatCount | null;
  setSelectedCatCount: (count: CatCount) => void;
  isValid: () => boolean;
}

export function useCatCountForm(
  initialCatCount: number,
): IUseCatCountFormReturn {
  const getInitialCatCount = (): CatCount | null => {
    if (initialCatCount === 0) {
      return null;
    }
    if (initialCatCount >= MAX_CAT_COUNT) {
      return MAX_CAT_COUNT;
    }
    return initialCatCount as CatCount;
  };

  const [ selectedCatCount, setSelectedCatCount ] = useState<CatCount | null>(getInitialCatCount());

  const isValid = (): boolean => selectedCatCount !== null;

  return {
    selectedCatCount,
    setSelectedCatCount,
    isValid,
  };
}
